import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NoticeViolation } from '../../../models/notice-violation.model';
import { NeighborhoodService } from '../../../services/neighborhood.service';
import { NoticeViolationService } from '../../../services/notice-violation.service';
import { CreateNoticeViolationModalComponent } from '../../../components/create-notice-violation-modal/create-notice-violation-modal.component';
import { NoticeViolationModalComponent } from '../../../components/notice-violation-modal/notice-violation-modal.component';

@Component({
  selector: 'app-notice-violations-page',
  templateUrl: './notice-violations-page.component.html',
  styleUrl: './notice-violations-page.component.scss'
})
export class NoticeViolationsPageComponent {

  public neighborhoodId?: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    public neighborhoodService: NeighborhoodService,
    public noticeViolationService: NoticeViolationService
  ) {
    this.activatedRoute.params.subscribe(
      async params => {
        this.neighborhoodId = params['neighborhoodId'];
        await this.noticeViolationService.getAll(this.neighborhoodId!);
      }
    );
  }

  /** true solo cuando ya cargó ESTE fraccionamiento y su módulo está apagado. */
  get moduleDisabled(): boolean {

    const neighborhood = this.neighborhoodService.currentNeighborhood;

    return !!neighborhood
      && neighborhood.neighborhoodId === this.neighborhoodId
      && !neighborhood.noticeViolationModule;
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR delete                                */
  /* -------------------------------------------------------------------------- */
  // region delete
  async delete(
    noticeViolation: NoticeViolation
  ) {
    const flag = confirm(
      `¿Está seguro que desea borrar la amonestación "${noticeViolation.title}"? Se eliminarán también sus archivos y notificaciones.`
    );

    if (flag) {
      await this.noticeViolationService.delete(noticeViolation);
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR create                                */
  /* -------------------------------------------------------------------------- */
  // region create
  create() {
    const modalRef = this.modalService.open(
      CreateNoticeViolationModalComponent
    );

    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
  }

  /* -------------------------------------------------------------------------- */
  /*                                 ANCHOR view                                */
  /* -------------------------------------------------------------------------- */
  // region view
  view(
    noticeViolation: NoticeViolation,
    editable: boolean = false
  ) {
    const modalRef = this.modalService.open(
      NoticeViolationModalComponent
    );

    modalRef.componentInstance.noticeViolation = noticeViolation;
    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
    modalRef.componentInstance.editable = editable;
  }

}
